
import { css } from 'lit';
export default css`
.prefooter-wrapper {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: block;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
}@media (min-width: 1024px) {.prefooter-wrapper {
    padding-left: 7rem;
    padding-right: 7rem;
  }
}@media (min-width: 1200px) {.prefooter-wrapper {
    padding-left: 10rem;
    padding-right: 10rem;
  }
}.prefooter-wrapper {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
  padding-top: 5rem;
  padding-bottom: 3rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  margin-top: 85px;
  margin-bottom: -85px;
}@media (min-width: 1024px) {.prefooter-wrapper {
    margin-top: 7rem;
    margin-bottom: -7rem;
  }
  }.prefooter-wrapper:before {
    content: "";
    position: absolute;
    left: 50%;
    width: 1px;
    height: 60%;
    top: 20%;
  }@media (min-width: 768px) {.prefooter-wrapper:before {
    border-right-width: 1px;
  }
}@media (min-width: 768px) {.prefooter-wrapper:before {
    --tw-border-opacity: 1;
    border-color: rgba(164, 167, 171, var(--tw-border-opacity));
  }
}.prefooter-wrapper .prefooter {
  border-bottom-width: 1px;
}.prefooter-wrapper .prefooter {
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}.prefooter-wrapper .prefooter {
  padding-bottom: 2.5rem;
}@media (min-width: 768px) {.prefooter-wrapper .prefooter {
    display: flex;
  }
}@media (min-width: 768px) {.prefooter-wrapper .prefooter {
    justify-content: space-between;
  }
}@media (min-width: 768px) {.prefooter-wrapper .prefooter {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}@media (min-width: 768px) {.prefooter-wrapper .prefooter {
    padding-left: 0px;
    padding-right: 0px;
  }
}.prefooter-wrapper .prefooter--column-2 {
  padding-top: 3rem;
}
`;